import React from "react";
// Chakra imports
import {
  Box,
  HStack,
  Container,
  Image,
  VStack,
  Heading,
  Flex,
  Text,
  Center,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import Pattern from "assets/images/pattern_auth.png";
import CoatOfArm from "assets/images/coat_of_arm.png";

function AuthIllustration(props) {
  const { children, illustrationImage, heading } = props;
  return (
    <Container
      width="100%"
      maxW="100%"
      background="#fff"
      padding="0px"
      h={{
        sm: "initial",
        md: "unset",
        lg: "110vh",
        xl: "110vh",
      }}
    >
      <HStack w="100%">
        <Box
          p="0"
          width="40%"
          h="120%"
          minH="125vh"
          background="brand.500"
          backgroundImage={Pattern}
          backgroundRepeat="repeat"
          backgroundSize="cover"
          pb="10"
          display={{ sm: "none", md: "block" }}
        >
          <Center width="100%" height="120%">
            <VStack boxSize="sm" width="100%" spacing="8" mt="10vh" mx="auto">
              <Box display="flex" alignItems="center" justifyContent="center">
                <Image src={CoatOfArm} width="30%" height="auto" />
              </Box>
              <Box width="80%">
                <Heading
                  mt="2"
                  size={{ sm: "md", md: "lg", lg: "lg" }}
                  textAlign={"center"}
                  color={"#ffffff"}
                  fontFamily="ManropeSemiBold"
                  fontWeight="bold"
                >
                  {heading}
                </Heading>
              </Box>
              <Box display="flex" alignItems="center" justifyContent="center">
                <Image src={illustrationImage} width="35%" height="auto" />
              </Box>
              <Box width="100%" textAlign={"center"}>
                <Link to="/public/data">
                  <Text
                    color="white"
                    fontSize={{ sm: "lg", md: "xl" }}
                    textDecoration={"underline"}
                  >
                    {" "}
                    Peer 2 Peer Status Page
                  </Text>
                </Link>
              </Box>
            </VStack>
          </Center>
        </Box>

        <Box width={{ sm: "100%", md: "60%" }} zIndex={0}>
          {children}
          <Box width="100%" position="fixed" bottom="0" bg="white" p="2">
            <Flex gap="4">
              <a href="https://ned.gov.ng/ncvs_terms.html" target="_blank">
                Terms & Conditions
              </a>
              <a href="https://ned.gov.ng/privacy-policy.html" target="_blank">
                Privacy Policy
              </a>
            </Flex>
          </Box>
        </Box>
      </HStack>
    </Container>
  );
}
// PROPS

AuthIllustration.propTypes = {
  illustrationBackground: PropTypes.string,
  image: PropTypes.any,
};

export default AuthIllustration;
